export default __webpack_public_path__ + "static/media/kale_red_russian.6d41a056.PNG";